import {
    type Filter,
    type FilterComponents,
    type FilterData,
} from '@itinerary/ItineraryModuleTypes';
import { FlightFilters } from '@itinerary/trip/flight/FlightModuleTypes';
import { type TripType } from '@utils/trip';
import { PaxType } from '@utils/types';

/**
 * Holds titles of each passenger type
 *
 * @type {any}
 */
const PaxTypeTitles: any = {};
PaxTypeTitles[PaxType.Adult] = 'بزرگسال';
PaxTypeTitles[PaxType.Child] = 'کودک';
PaxTypeTitles[PaxType.Infant] = 'نوزاد';
PaxTypeTitles[PaxType.Seat] = 'بزرگسال';
PaxTypeTitles[PaxType.EmptySeat] = 'صندلی خالی';
export { PaxTypeTitles };

/**
 * Information of suggestion for the related vehicle
 */
export interface Suggestion {
    /**
     * Id of the suggetion form
     *
     * @type {string}
     * @memberof Suggestion
     */
    fromID: string;

    /**
     * Title of the suggetion form
     *
     * @type {string}
     * @memberof Suggestion
     */
    fromTitle: string;

    /**
     * Id of the destination of suggestions
     *
     * @type {string}
     * @memberof Suggestion
     */
    toID: string;

    /**
     * Title of the destination of suggestions
     *
     * @type {string}
     * @memberof Suggestion
     */
    toTitle: string;

    /**
     * Minimum price of suggestions
     *
     * @type {number}
     * @memberof Suggestion
     */
    minPrice: number;

    /**
     * The key (identifier) dedicated to suggested trip module for using in furthur suggestion loading
     *
     * @type {string}
     * @memberof Suggestion
     */
    key: string;
}

/**
 * Location details of an specific poin of the map
 */
export interface Point {
    /**
     * The latitude of the point
     *
     * @type {number}
     * @memberof Point
     */
    latitude: number;

    /**
     * The longitude of the point
     *
     * @type {number}
     * @memberof Point
     */
    longitude: number;
}

/**
 * Information of the root
 */
export interface TripShareInfo {
    /**
     * Geographical location of origin of the trip
     *
     * @type {{number,number}}
     * @memberof TripShareInfo
     */
    origin: {
        latitude: number;
        longitude: number;
    };

    /**
     * Geographical location of destination of the trip
     *
     * @type {{number,number}}
     * @memberof TripShareInfo
     */
    destination: {
        latitude: number;
        longitude: number;
    };

    /**
     * route adult count
     *
     * @type {number}
     * @memberof TripShareInfo
     */
    adultCount: number;

    /**
     * route child count
     *
     * @type {number}
     * @memberof TripShareInfo
     */
    childCount: number;

    /**
     * route infant count
     *
     * @type {number}
     * @memberof TripShareInfo
     */
    infantCount: number;
    tripType: TripType;
    departureDate: Date | null;
    returnDate: Date | null;
    expectedPackagesToBeSelected: number;
    isSelectingReturn: boolean;
}
export type DurationFilterConfig<T extends number | number[]> = {
    departure: T;
    return?: T;
};

export class DurationFilter implements Filter {
    component: FilterComponents = 'DurationFilter';
    name = FlightFilters.Duration;
    items = null;
    title = 'مدت پرواز';
    constructor(
        public roundTrip: boolean,
        public min: DurationFilterConfig<number>,
        public max: DurationFilterConfig<number>
    ) {}
}

/**
 * Informations of a filter applied to time of trips
 */
export class TimeFilter implements Filter {
    /**
     * Name of the filter component (TimeFilter)
     *
     * @type {string}
     * @memberof TimeFilter
     */
    component: FilterComponents = 'TimeFilter';

    items = null;

    /**
     * Creates an instance of TimeFilter
     *
     * @param {string} name
     * @param {string} origin
     * @param {string} destination
     * @param {string} title
     * @memberof TimeFilter
     */
    constructor(
        public name: string,
        public origin: string,
        public destination: string,
        public title = 'زمان'
    ) {}
}

/**
 * Specifies sort metrics
 */
export enum TripSortBy {
    Price = 'price',
    Time = 'time',
    Duration = 'duration',
    MrbilitOffer = 'mrbilitOffer',
}

export interface TripFilters {
    key: string;
    meta: FilterData;
}
